import { getAdapterForInstitution } from "@/services/transactionsImport/adapterRegistry";
import { parseTabularFile } from "@/services/transactionsImport/fileTableParser";
import { validateAndNormalizeTransactions } from "@/services/transactionsImport/sharedValidatorNormalizer";

export async function parseInstitutionTransactionsFile({
  file,
  institutionName,
  detailsToInclude = [],
}) {
  const adapter = getAdapterForInstitution(institutionName);

  if (!adapter) {
    throw new Error(
      `No transaction adapter found for institution: ${institutionName}`
    );
  }

  const detailsValidation =
    typeof adapter.validateDetailsToInclude === "function"
      ? adapter.validateDetailsToInclude(detailsToInclude)
      : {
          normalized: Array.isArray(detailsToInclude) ? detailsToInclude : [],
          invalid: [],
          allowed: Array.isArray(adapter.supportedDetailFields)
            ? adapter.supportedDetailFields
            : [],
        };

  if (detailsValidation.invalid.length > 0) {
    const allowedFields = detailsValidation.allowed.length
      ? detailsValidation.allowed.join(", ")
      : "None";

    throw new Error(
      `Invalid detailsToInclude fields for adapter "${
        adapter.name
      }": ${detailsValidation.invalid.join(
        ", "
      )}. Allowed fields: ${allowedFields}`
    );
  }

  const rows = await parseTabularFile(file);
  const extractedTransactions = adapter.extractTransactions(rows, {
    detailsToInclude: detailsValidation.normalized,
  });
  const { transactions, errors } = validateAndNormalizeTransactions(
    extractedTransactions
  );

  return {
    adapterName: adapter.name,
    transactions,
    errors,
    totalExtracted: extractedTransactions.length,
    totalValid: transactions.length,
  };
}
